import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

import BackButton from './BackButton/BackButton'
import MenuButton from './MenuButton/MenuButton'
import PackageItem from './PackageItem/PackageItem'
import LessonItem from './LessonItem/LessonItem'
import SidebarContent from './SidebarContent/SidebarContent'
import Sidebar from 'react-sidebar'
import { useSelector, useDispatch } from 'react-redux'
import { saveLastPackageIndex } from '../../../store/actions'
import Progress from './Progress/Progress'

const SCREEN_MAIN = 0;
const SCREEN_PROGRESS = 1;
const SCREEN_PREMIUM = 2;


const Home = ({
    userType,
    displayName,
    width,
    onLogoutClick,
    packages,
    packsProgress,
    scores,
    maxPacksProgress,
    words,
}) => {

    const history = useHistory();
    const dispatch = useDispatch();

    const [sidebarOpen, setSidebarOpen] = useState(false)

    const [selectedPackage, setSelectedPackage] = useState(useSelector(state => state.lastPackageIndex))
    const [currScreen, setCurrScreen] = useState(SCREEN_MAIN)

    const onPackageClick = (index) => {
        setSelectedPackage(index)
    }

    const onLessonClick = (lesson) => {
        dispatch(saveLastPackageIndex(selectedPackage))
        history.push('/course', {
            selectedPackage: selectedPackage,
            lesson: lesson,
            page: 'LESSON',
        })
    }

    let content = null

    switch (currScreen) {
        case SCREEN_MAIN:
            if (selectedPackage === -1) {
                content = packages ?
                    <>
                        {packages.map((pack, index) => {
                            return <PackageItem
                                key={String(index)}
                                progress={packsProgress ? packsProgress[index] : 0}
                                maxProgress={Number(pack.lesson_count)}
                                title={pack.package_name}
                                imageUrl={pack.package_image}
                                onClick={() => onPackageClick(index)}
                                width={width} />
                        })}
                    </> : null
            }
            else {
                content = <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    padding: '16px',
                    justifyContent: 'center',
                }}>
                    {packages[selectedPackage].lessons.map((lesson, index) => {
                        return <LessonItem
                            key={String(index)}
                            title={lesson.name}
                            scores={scores[lesson.id]}
                            stages={lesson.stages}
                            imageUrl={lesson.img_path}
                            open={index <= maxPacksProgress[selectedPackage]}
                            onClick={() => onLessonClick(lesson)}
                        />
                    })}
                </div>
            }
            break

        case SCREEN_PROGRESS:
            content = <Progress
                words={words} />
            break

        case SCREEN_PREMIUM:

            break
    }
    
    return (
        <Sidebar
            sidebar={<SidebarContent
                words={words}
                userType={userType}
                displayName={displayName}
                onLogoutClick={onLogoutClick}
                currScreen={currScreen}
                onHomeClick={() => setCurrScreen(SCREEN_MAIN)}
                onBecomePremiumClick={() => setCurrScreen(SCREEN_PREMIUM)}
                onProgressClick={() => setCurrScreen(SCREEN_PROGRESS)} />}
            open={sidebarOpen}
            docked={width >= 800}
            onSetOpen={(open) => setSidebarOpen(open)}
            styles={{
                sidebar: {
                    background: "white",
                    zIndex: 200
                },
                root: {
                    backgroundColor: '#eee',
                }
            }}
        >
            {
                selectedPackage === -1 || currScreen !== SCREEN_MAIN ? null :
                    <BackButton
                        onClick={() => setSelectedPackage(-1)} />
            }
            {
                width > 800 ? null :
                    <MenuButton onClick={() => setSidebarOpen(true)} />
            }
            {content}
        </Sidebar>
    )
}

export default Home
